var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-item p-0" },
      [
        _vm.hasSiblings
          ? _c("RelatedPaymentsHeader", {
              attrs: {
                "current-user-is-client": _vm.currentUserIsClient,
                "payments-status": _vm.paymentsStatus,
                "related-payment-id": _vm.relatedPaymentId,
                disabled:
                  _vm.allCheckBoxesAreDisabled ||
                  (_vm.paymentsStatus.paymentsAreNotTheFirst &&
                    !_vm.paymentsStatus.arePreviousPaymentsInPaymentsMap),
                payments: _vm.payments,
                "payment-index": _vm.paymentIndex,
                "global-extended-payment": _vm.globalExtendedPayment,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("change", $event)
                },
                "extend-payment": function ($event) {
                  return _vm.$emit("extend-payment")
                },
              },
            })
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "transition-fast",
            class: [
              _vm.hasSiblings
                ? _vm.globalExtendedPayment === _vm.relatedPaymentId &&
                  (_vm.paymentsStatus.anyPaymentsInPaymentsMap ||
                    _vm.paymentsStatus.somePaymentsArePending)
                  ? "show"
                  : "hide"
                : "",
            ],
          },
          _vm._l(_vm.payments, function (payment) {
            return _c(
              "div",
              {
                key: `payment-${payment.operationId}-${payment.paymentNumber}`,
                class: { "m-5": _vm.hasSiblings },
                attrs: {
                  id: `payment-${payment.operationId}-${payment.paymentNumber}`,
                },
              },
              [
                _c("SinglePayment", {
                  class: {
                    extended:
                      _vm.extendedPayment ===
                      `${payment.operationId}-${payment.paymentNumber}`,
                  },
                  style: `z-index: ${
                    _vm.extendedPayment ===
                    `${payment.operationId}-${payment.paymentNumber}`
                      ? 20
                      : "auto"
                  }`,
                  attrs: {
                    id: `id-${payment.operationId}-${payment.paymentNumber}`,
                    "current-user-is-client": _vm.currentUserIsClient,
                    "collect-client-debt": _vm.collectClientDebt,
                    payment: payment,
                    operation: _vm.operation,
                    type: payment.type,
                    "has-siblings": _vm.hasSiblings,
                    checked:
                      _vm.paymentsMap[payment.operationId] &&
                      _vm.paymentsMap[payment.operationId].some(
                        (p) => p.paymentNumber === payment.paymentNumber
                      ),
                    "is-payment-loading":
                      _vm.currentLoadingPayment ===
                      `${payment.operationId}-${payment.paymentNumber}`,
                    "show-remove-late-charges": _vm.showRemoveLateCharges,
                    disabled:
                      (_vm.allCheckBoxesAreDisabled &&
                        _vm.currentLoadingPayment !==
                          `${payment.operationId}-${payment.paymentNumber}`) ||
                      // es el primer pago de la operación a la que corresponde
                      (payment.paymentIndex > 0 &&
                        !(
                          // existe la operación en el mapa
                          (
                            _vm.paymentsMap[payment.operationId] &&
                            // existe la cuota anterior en el mapa
                            _vm.paymentsMap[payment.operationId][
                              payment.paymentIndex - 1
                            ] &&
                            // la cuota anterior + 1 es igual a la cuota actual
                            _vm.paymentsMap[payment.operationId][
                              payment.paymentIndex - 1
                            ].paymentNumber +
                              1 ===
                              payment.paymentNumber
                          )
                        )),
                    "is-extended":
                      // Si no hay más payments y la cuota extendida en clientOps es la actual
                      (!_vm.hasSiblings &&
                        _vm.globalExtendedPayment ===
                          `${payment.operationId}-${payment.paymentNumber}`) ||
                      // O, si hay más de un payment y el actual está extendido
                      (_vm.hasSiblings &&
                        _vm.extendedPayment ===
                          `${payment.operationId}-${payment.paymentNumber}`),
                  },
                  on: {
                    "confirm-deselect-payment": function ($event) {
                      return _vm.$emit("confirm-deselect-payment", $event)
                    },
                    "extend-payment": function ($event) {
                      return _vm.extendPayment(
                        `${payment.operationId}-${payment.paymentNumber}`
                      )
                    },
                    "remove-late-charges": function ($event) {
                      return _vm.removeLateCharges($event, _vm.extendedPayment)
                    },
                    change: function ($event) {
                      return _vm.$emit("change", $event)
                    },
                    "undo-remove-late-charges": function ($event) {
                      return _vm.undoRemoveLateCharges(
                        $event,
                        _vm.extendedPayment
                      )
                    },
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }